<nz-layout class="height-full">
    <nz-sider nzTheme="light" nzWidth="351px">
        <div class="am-dash-sider-container">
            <div class="am-dash-filter-panel am-dash-sider-content">
                <app-saved-dashboard-view></app-saved-dashboard-view>
                <div *ngFor="let link of [modify_time_users_datasource]">
                    <app-data-text
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-data-text>
                </div>
                <!-- Active Day / Install Day toggle -->
                <app-toggle [option]="settingDayMode.options"></app-toggle>
                <!-- Limit max day_no -->
                <app-single-select
                    [option]="settingMaxDayNo.options"
                ></app-single-select>
                <!-- User type visibility -->
                <div
                    style="
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                    "
                >
                    <app-checkbox
                        [option]="settingShowAllUsers.options"
                    ></app-checkbox>
                    <app-checkbox
                        [option]="settingShowMetaUsers.options"
                    ></app-checkbox>
                    <app-checkbox
                        [option]="settingShowHopaUsers.options"
                    ></app-checkbox>
                    <app-checkbox
                        [option]="settingShowMetaProductiveUsers.options"
                    ></app-checkbox>
                    <app-checkbox
                        [option]="settingShowCoreLoopUsers.options"
                    ></app-checkbox>
                </div>
                <app-single-select
                    [option]="settingItemDateAggregation.options"
                ></app-single-select>
                <app-toggle
                    [option]="settingItemCurrency.options"
                ></app-toggle>
                <div *ngFor="let link of values(filterDashboardItemLinks)">
                    <app-category-filter-dashboard-item
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'CategoryFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                    </app-category-filter-dashboard-item>
                    <app-date-picker
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'DateRangeFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                        ></app-date-picker
                    >
                    <app-segment-filter
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'SegmentsFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-segment-filter>
                </div>
            </div>
            <div class="am-dash-sider-footer">
                <div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            nzType="primary"
                            (click)="applyChangedFilters()"
                            [disabled]="isApplyButtonDisabled"
                            style="flex-grow: 1"
                        >
                            Apply
                        </button>
                    </div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            color="primary"
                            (click)="standardDashboardInitialize()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Restore defaults
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="reloadData()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Reload data
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="requestNewSegmentsProcessing()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Process new Segments
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </nz-sider>
    <nz-content class="am-dash-main-content">
        <div class="am-dash-legend-card">
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="24">
                    <app-common-legend></app-common-legend>
                </div>
            </div>
        </div>
        <div class="main-container">
            <div class="grid-container">
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="24" *ngFor="let link of [dau]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>

                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="
                            let link of [
                                median_new_decos_placed_per_active_user_by_date,
                                average_new_decos_placed_per_active_user_by_date,
                                median_new_decos_placed_per_active_user_by_day_no,
                                average_new_decos_placed_per_active_user_by_day_no,
                            ]
                        "
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>

                <app-table-dashboard-item
                    [dashboardItem]="kpi_summary_table.dashboardItem"
                    [dataLoaderEmitter]="kpi_summary_table.dataLoaderEmitter"
                ></app-table-dashboard-item>
            </div>
        </div>
    </nz-content>
</nz-layout>
